var map = {
	"./bag1.svg": "c54a",
	"./bag2.svg": "80c6",
	"./bag3.svg": "bb4c",
	"./hat1.svg": "7864",
	"./jacket1.svg": "383c",
	"./jacket2.svg": "279a",
	"./jeans1.svg": "2fe4",
	"./shoe1.svg": "5057",
	"./shoe2.svg": "4a0d",
	"./shoe3.svg": "8330",
	"./shoe4.svg": "216f",
	"./sweater1.svg": "2334",
	"./tshirt1.svg": "142a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e246";